export default "__VITE_ASSET__CODahZOG__"